// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React from "react";
import _ from "lodash";
import { FontIcon } from "@fluentui/react";
import { IProject, AssetState, IAsset } from "../../../models/applicationState";
import { strings, interpolate } from "../../../common/strings";
import "./statusBarMetrics.scss";

export interface IStatusBarMetricsProps {
    project: IProject;
    emitAssets: Function;
}

export interface IStatusBarMetricsState {
    projectAssets: IAsset[];
    newAssets: IAsset[];
    taggedAssets: IAsset[];
}

export default class StatusBarMetrics extends React.Component<
    IStatusBarMetricsProps,
    IStatusBarMetricsState
> {
    constructor(props) {
        super(props);

        const projectAssets = _.values(this.props.project.assets);
        const newAssets = projectAssets.filter(
            (asset) => asset.state !== AssetState.Tagged
        );
        const taggedAssets = projectAssets.filter(
            (asset) => asset.state === AssetState.Tagged
        );

        this.state = {
            projectAssets,
            newAssets,
            taggedAssets,
        };
    }

    public render() {
        if (!this.props.project) {
            return null;
        }

        return (
            <div className="status-bar">
                <ul>
                    <li
                        onClick={() =>
                            this.props.emitAssets(this.state.newAssets)
                        }
                        title={interpolate(strings.projectMetrics.newAssets, {
                            count: this.state.newAssets.length,
                        })}
                    >
                        <FontIcon iconName="View" />
                        <span className="metric-visited-asset-count">
                            {this.state.newAssets.length}
                        </span>
                    </li>
                    <li
                        onClick={() =>
                            this.props.emitAssets(this.state.taggedAssets)
                        }
                        title={interpolate(
                            strings.projectMetrics.taggedAssets,
                            {
                                count: this.state.taggedAssets.length,
                            }
                        )}
                    >
                        <FontIcon iconName="Tag" />
                        <span className="metric-tagged-asset-count">
                            {this.state.taggedAssets.length}
                        </span>
                    </li>

                    <li
                        onClick={() =>
                            this.props.emitAssets(this.state.projectAssets)
                        }
                        title={`Total Assets (${this.state.projectAssets.length})`}
                    >
                        <FontIcon iconName="TextDocument" />
                        <span className="metric-asset-count">
                            {this.state.projectAssets.length}
                        </span>
                    </li>
                </ul>
            </div>
        );
    }
}
